import React from 'react';

import { NoBlogs } from './styled';

const BlogsNotFound: React.FC = () => {
  return (
    <NoBlogs>
      <div className="main">
        <svg width="110" height="116" viewBox="0 0 110 116" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100.689 114.096L78.491 88.0912C77.7734 87.2672 77.407 86.1949 77.4704 85.1041C77.5339 84.0132 78.0221 82.9906 78.8304 82.2553C79.6386 81.52 80.7026 81.1305 81.7946 81.1702C82.8866 81.21 83.9195 81.6758 84.6722 82.4679L108.462 107.023C108.95 107.53 109.331 108.129 109.583 108.785C109.835 109.441 109.953 110.141 109.93 110.843C109.907 111.546 109.743 112.237 109.448 112.875C109.154 113.513 108.734 114.086 108.214 114.559C107.694 115.032 107.085 115.396 106.421 115.629C105.758 115.863 105.055 115.961 104.354 115.917C103.652 115.874 102.966 115.691 102.337 115.378C101.707 115.065 101.147 114.629 100.689 114.096V114.096Z"
            fill="url(#paint0_linear_406_1639)"
          />
          <path
            d="M53.8317 0C43.1848 0 32.777 3.15718 23.9245 9.07228C15.0719 14.9874 8.17211 23.3947 4.09772 33.2312C0.0233256 43.0676 -1.04272 53.8914 1.03438 64.3337C3.11149 74.7761 8.23842 84.3679 15.7669 91.8964C23.2954 99.4249 32.8872 104.552 43.3296 106.629C53.7719 108.706 64.5957 107.64 74.4322 103.566C84.2687 99.4913 92.676 92.5915 98.5911 83.739C104.506 74.8864 107.663 64.4786 107.663 53.8317C107.663 39.5546 101.992 25.8623 91.8965 15.7669C81.8011 5.67153 68.1087 0 53.8317 0ZM53.8317 101.488C44.406 101.489 35.1917 98.6946 27.354 93.4588C19.5163 88.2229 13.4072 80.7805 9.79944 72.0726C6.19163 63.3647 5.24714 53.7825 7.08533 44.5378C8.92353 35.2931 13.4619 26.8012 20.1265 20.1358C26.791 13.4705 35.2825 8.93115 44.527 7.09189C53.7715 5.25263 63.3538 6.19605 72.0621 9.80286C80.7704 13.4097 88.2136 19.5178 93.4503 27.3549C98.687 35.192 101.482 44.406 101.482 53.8317C101.481 66.4694 96.4601 78.5892 87.5244 87.526C78.5886 96.4627 66.4694 101.485 53.8317 101.488Z"
            fill="#AECC7E"
          />
          <path
            d="M101.482 53.8316C101.482 54.8053 101.455 55.7735 101.395 56.7363C101.362 57.338 101.318 57.9452 101.253 58.5359C100.132 69.8586 94.9966 80.4066 86.7758 88.2729C78.555 96.1392 67.7911 100.805 56.43 101.426C45.0689 102.047 33.8605 98.5827 24.8312 91.6594C15.8019 84.7362 9.54756 74.8109 7.19895 63.6779C7.07314 63.098 6.96368 62.5237 6.86522 61.9329C4.89428 50.5117 7.15262 38.7636 13.2176 28.8871C19.2825 19.0106 28.7385 11.6825 39.816 8.2741C50.8936 4.86568 62.8335 5.61053 73.4016 10.3693C83.9696 15.128 92.4416 23.5745 97.2321 34.1282C97.4782 34.6752 97.7188 35.2222 97.9376 35.7692C100.288 41.5007 101.492 47.6371 101.482 53.8316Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_406_1639"
              x1="77.4899"
              y1="98.572"
              x2="109.944"
              y2="98.572"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#97AE72" />
              <stop offset="0.32" stopColor="#BBD78D" />
              <stop offset="0.6" stopColor="#BBD78D" />
              <stop offset="0.84" stopColor="#CEEE99" />
              <stop offset="1" stopColor="#CEE9A2" />
            </linearGradient>
          </defs>
        </svg>

        <div className='headline'>ბლოგი არ მოიძებნა</div>

        <p>აღნიშნული ფილტრებით ბლოგი არ მოიძებნა ჩვენს ბაზაში, გთხოვთ გამოიყენოთ სხვა პარამეტრები</p>
      </div>
    </NoBlogs>
  );
};

export default BlogsNotFound;
